import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import FilledRoundedButton from '../../components/Button/FilledRoundedButton';
import TextInput from '../../components/TextInput';
import Loading from '../../components/Loading';
import Pagination from '@mui/material/Pagination';
import { CSVLink } from 'react-csv';
import Dashboard from '../Dashboard';
import { fetchAllData } from '../Transaction/FetchAllData';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import qatekLogo from '../../images/qatek-logo.png';

const tableHeader = [
    { name: 'Date', size: 'medium' },
    { name: 'Description', size: 'medium' },
    { name: 'Type', size: 'medium' },
    { name: 'Amount', size: 'medium' },
    { name: 'Branch', size: 'medium' },
];

function IncomeStatement() {
    const dispatch = useDispatch();
    const [combinedData, setCombinedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(() => {
        const currentYear = new Date().getFullYear();
        return `${currentYear}-01-01`;
    });
    const [endDate, setEndDate] = useState(() => {
        const currentYear = new Date().getFullYear();
        return `${currentYear}-12-31`;
    });
    const [filterOpen, setFilterOpen] = useState(false);
    const [typeFilter, setTypeFilter] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [branches, setBranches] = useState([]);
    const [branchFilter, setBranchFilter] = useState('');

    const toggleFilter = () => {
        setFilterOpen(!filterOpen);
        setTypeFilter('');
        setBranchFilter('');
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                // Fetch all data
                const allData = await fetchAllData(dispatch);

                // Process the fetched data
                const { allTransactions, jobSupportData, enrolledData, otherIncomeData } = allData;
                const uniqueBranches = [...new Set(allTransactions.map(transaction => transaction.branch))];
                setBranches(uniqueBranches);

                const combinedData = [];

                // Process all transactions
                allTransactions.forEach(transaction => {
                    combinedData.push({
                        date: (transaction.expense?.date || transaction?.income_software_training?.date) ? (transaction.expense?.date || transaction?.income_software_training?.date.split(' ')[0]) : null,
                        amount: transaction.amount,
                        description: transaction.expense?.description || transaction?.income_software_training?.description,
                        classification: transaction.expense.classification,
                        type: transaction.type,
                        branch: transaction.branch
                    });
                });

                // // Process job support data
                // jobSupportData.forEach(jobSupport => {
                //     const name = jobSupport?.name || `${jobSupport?.student_record?.first_name} ${jobSupport?.student_record?.last_name}` || 'Unknown';
                //     const id = jobSupport?.id;
                //     const enrolledProgram = jobSupport?.student_record?.enrolled_program || 'Not Given';

                //     // Check if deposit exists and is not "0.00"
                //     if (jobSupport.job_support_record_payment?.deposit && jobSupport.job_support_record_payment?.deposit !== "0.00") {
                //         combinedData.push({
                //             date: jobSupport.job_support_record_payment?.deposit_payment_date,
                //             amount: jobSupport.job_support_record_payment?.deposit,
                //             description: `${name}, ID: ${id}, ${enrolledProgram}, Deposit Payment (Job Support)`,
                //             type: 'Deposit',
                //             branch: 'Online'
                //         });
                //     }
                // });


                // jobSupportData.forEach(jobSupport => {
                //     const name = jobSupport?.name || `${jobSupport?.student_record?.first_name} ${jobSupport?.student_record?.last_name}` || 'Unknown';
                //     const id = jobSupport?.id;
                //     const enrolledProgram = jobSupport?.student_record?.enrolled_program || 'Not Given';
                //     if (jobSupport.job_support_record_payment?.first_payment_date) {
                //         combinedData.push({
                //             date: jobSupport.job_support_record_payment.first_payment_date,
                //             amount: jobSupport.job_support_record_payment.first_payment_status,
                //             description: `${name}, ID: ${id}, ${enrolledProgram}, First Installment (Job Support)`,
                //             type: 'Deposit',
                //             branch: 'Online'
                //         });
                //     }
                // });

                // jobSupportData.forEach(jobSupport => {
                //     const name = jobSupport?.name || `${jobSupport?.student_record?.first_name} ${jobSupport?.student_record?.last_name}` || 'Unknown';
                //     const id = jobSupport?.id;
                //     const enrolledProgram = jobSupport?.student_record?.enrolled_program || 'Not Given';
                //     if (jobSupport.job_support_record_payment?.second_payment_date) {
                //         combinedData.push({
                //             date: jobSupport.job_support_record_payment.second_payment_date,
                //             amount: jobSupport.job_support_record_payment.second_payment_status,
                //             description: `${name}, ID: ${id}, ${enrolledProgram}, Second Installment (Job Support)`,
                //             type: 'Deposit',
                //             branch: 'Online'
                //         });
                //     }
                // });
                // jobSupportData.forEach(jobSupport => {
                //     const name = jobSupport?.name || `${jobSupport?.student_record?.first_name} ${jobSupport?.student_record?.last_name}` || 'Unknown';
                //     const id = jobSupport?.id;
                //     const enrolledProgram = jobSupport?.student_record?.enrolled_program || 'Not Given';
                //     if (jobSupport.job_support_record_payment?.third_payment_date) {
                //         combinedData.push({
                //             date: jobSupport.job_support_record_payment.third_payment_date,
                //             amount: jobSupport.job_support_record_payment.third_payment_status,
                //             description: `${name}, ID: ${id}, ${enrolledProgram}, Third Installment (Job Support)`,
                //             type: 'Deposit',
                //             branch: 'Online'
                //         });
                //     }
                // });

                // jobSupportData.forEach(jobSupport => {

                //     if (jobSupport.new_job_support_payment.length > 0) {
                //         jobSupport.new_job_support_payment.forEach(paymentInfo => {
                //             if (paymentInfo.deposit) {
                //                 combinedData.push({
                //                     date: paymentInfo.deposit_payment_date,
                //                     amount: paymentInfo.deposit,
                //                     type: 'Deposit',
                //                 });
                //             }

                //             if (paymentInfo.first_payment_status) {
                //                 combinedData.push({
                //                     date: paymentInfo.first_payment_date,
                //                     amount: paymentInfo.first_payment_status,
                //                     type: 'Deposit',
                //                 });
                //             }

                //             if (paymentInfo.second_payment_status) {
                //                 combinedData.push({
                //                     date: paymentInfo.second_payment_date,
                //                     amount: paymentInfo.second_payment_status,
                //                     type: 'Deposit',
                //                 });
                //             }
                //             if (paymentInfo.third_payment_status) {
                //                 combinedData.push({
                //                     date: paymentInfo.third_payment_date,
                //                     amount: paymentInfo.third_payment_status,
                //                     type: 'Deposit',
                //                 });
                //             }
                //         });
                //     }
                // });

                jobSupportData.forEach(jobSupport => {
                    const name = jobSupport?.name || `${jobSupport?.student_record?.first_name} ${jobSupport?.student_record?.last_name}` || 'Unknown';
                    const id = jobSupport?.id;
                    const enrolledProgram = jobSupport?.student_record?.enrolled_program || 'Not Given';

                    if (jobSupport.job_support_record_payment) {
                        if (jobSupport.job_support_record_payment?.deposit && jobSupport.job_support_record_payment?.deposit !== "0.00") {
                            combinedData.push({
                                date: jobSupport.job_support_record_payment?.deposit_payment_date,
                                amount: jobSupport.job_support_record_payment?.deposit,
                                description: `${name}, ID: ${id}, ${enrolledProgram}, Deposit Payment (Job Support)`,
                                type: 'Deposit',
                                branch: 'Online'
                            });
                        }

                        if (jobSupport.job_support_record_payment?.first_payment_date) {
                            combinedData.push({
                                date: jobSupport.job_support_record_payment.first_payment_date,
                                amount: jobSupport.job_support_record_payment.first_payment_status,
                                description: `${name}, ID: ${id}, ${enrolledProgram}, First Installment (Job Support)`,
                                type: 'Deposit',
                                branch: 'Online'
                            });
                        }

                        if (jobSupport.job_support_record_payment?.second_payment_date) {
                            combinedData.push({
                                date: jobSupport.job_support_record_payment.second_payment_date,
                                amount: jobSupport.job_support_record_payment.second_payment_status,
                                description: `${name}, ID: ${id}, ${enrolledProgram}, Second Installment (Job Support)`,
                                type: 'Deposit',
                                branch: 'Online'
                            });
                        }

                        if (jobSupport.job_support_record_payment?.third_payment_date) {
                            combinedData.push({
                                date: jobSupport.job_support_record_payment.third_payment_date,
                                amount: jobSupport.job_support_record_payment.third_payment_status,
                                description: `${name}, ID: ${id}, ${enrolledProgram}, Third Installment (Job Support)`,
                                type: 'Deposit',
                                branch: 'Online'
                            });
                        }

                        if (jobSupport.job_support_record_payment?.fourth_payment_date) {
                            combinedData.push({
                                date: jobSupport.job_support_record_payment.fourth_payment_date,
                                amount: jobSupport.job_support_record_payment.fourth_payment_status,
                                description: `${name}, ID: ${id}, ${enrolledProgram}, Fourth Installment (Job Support)`,
                                type: 'Deposit',
                                branch: 'Online'
                            });
                        }
                    }

                    if (jobSupport.new_job_support_payment.length > 0) {
                        jobSupport.new_job_support_payment.forEach(paymentInfo => {
                            if (paymentInfo.deposit && parseFloat(paymentInfo.deposit) > 0) {
                                const newEnrolledProgram = paymentInfo.job_support_count;
                                combinedData.push({
                                    date: paymentInfo.deposit_payment_date,
                                    amount: paymentInfo.deposit,
                                    description: `${name}, ID: ${id}, Job Support Count: ${newEnrolledProgram}, New Deposit Payment (Enrolled Student`,
                                    type: 'Deposit',
                                    branch: 'Online'
                                });
                            }

                            if (paymentInfo.first_payment_status && parseFloat(paymentInfo.first_payment_status) > 0) {
                                const newEnrolledProgram = paymentInfo.job_support_count;
                                combinedData.push({
                                    date: paymentInfo.first_payment_date,
                                    amount: paymentInfo.first_payment_status,
                                    description: `${name}, ID: ${id}, Job Support Count: ${newEnrolledProgram}, New First Installment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: 'Online'
                                });
                            }

                            if (paymentInfo.second_payment_status && parseFloat(paymentInfo.second_payment_status) > 0) {
                                const newEnrolledProgram = paymentInfo.job_support_count;
                                combinedData.push({
                                    date: paymentInfo.second_payment_date,
                                    amount: paymentInfo.second_payment_status,
                                    description: `${name}, ID: ${id}, Job Support Count: ${newEnrolledProgram}, New Second Installment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: 'Online'
                                });
                            }
                            if (paymentInfo.third_payment_status && parseFloat(paymentInfo.third_payment_status) > 0) {
                                const newEnrolledProgram = paymentInfo.job_support_count;
                                combinedData.push({
                                    date: paymentInfo.third_payment_date,
                                    amount: paymentInfo.third_payment_status,
                                    description: `${name}, ID: ${id}, Job Support Count: ${newEnrolledProgram}, New Third Installment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: 'Online'
                                });
                            }
                        });
                    }
                });


                // Process enrolled data
                enrolledData.forEach(enrolled => {
                    const name = enrolled?.name;
                    const id = enrolled?.id;
                    const enrolledProgram = enrolled?.enrolled_program || 'Not Given';

                    if (enrolled.payment_information?.enrollment_payment) {
                        combinedData.push({
                            date: enrolled.payment_information?.enrollment_payment_date,
                            amount: enrolled.payment_information?.enrollment_payment,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, Enrollment Payment (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }

                    if (enrolled.payment_information?.enrollment_installment_1_amount) {
                        combinedData.push({
                            date: enrolled.payment_information?.enrollment_installment_1_date,
                            amount: enrolled.payment_information?.enrollment_installment_1_amount,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, Enrollment Payment 1 (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }

                    if (enrolled.payment_information?.enrollment_installment_2_amount) {
                        combinedData.push({
                            date: enrolled.payment_information?.enrollment_installment_2_date,
                            amount: enrolled.payment_information?.enrollment_installment_2_amount,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, Enrollment Payment 2 (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }

                    if (enrolled.payment_information?.enrollment_installment_3_amount) {
                        combinedData.push({
                            date: enrolled.payment_information?.enrollment_installment_2_date,
                            amount: enrolled.payment_information?.enrollment_installment_3_amount,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, Enrollment Payment 3 (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }

                    if (enrolled.payment_information?.first_payment_date) {
                        combinedData.push({
                            date: enrolled.payment_information.first_payment_date,
                            amount: enrolled.payment_information.first_payment_status,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, First Installment (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }

                    if (enrolled.payment_information?.second_payment_date) {
                        combinedData.push({
                            date: enrolled.payment_information.second_payment_date,
                            amount: enrolled.payment_information.second_payment_status,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, Second Installment (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }

                    if (enrolled.payment_information?.third_payment_date) {
                        combinedData.push({
                            date: enrolled.payment_information.third_payment_date,
                            amount: enrolled.payment_information.third_payment_status,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, Third Installment (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }

                    if (enrolled.payment_information?.fourth_payment_date) {
                        combinedData.push({
                            date: enrolled.payment_information.fourth_payment_date,
                            amount: enrolled.payment_information.fourth_payment_status,
                            description: `${name}, ID: ${id}, ${enrolledProgram}, Fourth Installment (Enrolled Student)`,
                            type: 'Deposit',
                            branch: enrolled.location || 'Not Given'
                        });
                    }


                    if (enrolled.new_payment_information.length > 0) {
                        enrolled.new_payment_information.forEach(paymentInfo => {
                            if (paymentInfo.enrollment_payment && parseFloat(paymentInfo.enrollment_payment) > 0) {
                                const newEnrolledProgram = paymentInfo.enrolled_program;
                                combinedData.push({
                                    date: paymentInfo.enrollment_payment_date,
                                    amount: paymentInfo.enrollment_payment,
                                    description: `${name}, ID: ${id}, ${newEnrolledProgram}, New Enrollment Payment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: enrolled.location || 'Not Given'
                                });
                            }

                            if (paymentInfo.first_payment_status && parseFloat(paymentInfo.first_payment_status) > 0) {
                                const newEnrolledProgram = paymentInfo.enrolled_program;
                                combinedData.push({
                                    date: paymentInfo.first_payment_date,
                                    amount: paymentInfo.first_payment_status,
                                    description: `${name}, ID: ${id}, ${newEnrolledProgram}, New First Installment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: enrolled.location || 'Not Given'
                                });
                            }

                            if (paymentInfo.second_payment_status && parseFloat(paymentInfo.second_payment_status) > 0) {
                                const newEnrolledProgram = paymentInfo.enrolled_program;
                                combinedData.push({
                                    date: paymentInfo.second_payment_date,
                                    amount: paymentInfo.second_payment_status,
                                    description: `${name}, ID: ${id}, ${newEnrolledProgram}, New Second Installment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: enrolled.location || 'Not Given'
                                });
                            }
                            if (paymentInfo.third_payment_status && parseFloat(paymentInfo.third_payment_status) > 0) {
                                const newEnrolledProgram = paymentInfo.enrolled_program;
                                combinedData.push({
                                    date: paymentInfo.third_payment_date,
                                    amount: paymentInfo.third_payment_status,
                                    description: `${name}, ID: ${id}, ${newEnrolledProgram}, New Third Installment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: enrolled.location || 'Not Given'
                                });
                            }
                            if (paymentInfo.fourth_payment_status && parseFloat(paymentInfo.fourth_payment_status) > 0) {
                                const newEnrolledProgram = paymentInfo.enrolled_program;
                                combinedData.push({
                                    date: paymentInfo.fourth_payment_date,
                                    amount: paymentInfo.fourth_payment_status,
                                    description: `${name}, ID: ${id}, ${newEnrolledProgram}, New Fourth Installment (Enrolled Student)`,
                                    type: 'Deposit',
                                    branch: enrolled.location || 'Not Given'
                                });
                            }
                        });
                    }



                });


                // Process Other income data
                otherIncomeData.forEach(otherIncome => {
                    if (otherIncome.paid_amount) {
                        combinedData.push({
                            date: otherIncome.date,
                            amount: otherIncome.paid_amount,
                            description: otherIncome.detail,
                            type: 'Deposit',
                            branch: otherIncome.location || 'Not Given'
                        });
                    }

                });

                // Update state with the combined data sorted by date (latest to oldest)
                setCombinedData(
                    combinedData.sort((a, b) => {
                        const dateA = a.date ? new Date(a.date) : 0;
                        const dateB = b.date ? new Date(b.date) : 0;
                        return dateB - dateA;
                    })
                );
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        };
        fetchData();
    }, [dispatch]);

    // Memoized filtered data
    const filteredData = useMemo(() => {
        let filtered = combinedData;

        if (startDate && endDate) {
            filtered = filtered.filter(item => {
                const itemDate = new Date(item.date);
                const start = new Date(startDate);
                const end = new Date(endDate);
                return itemDate >= start && itemDate <= end;
            });
        }

        if (typeFilter) {
            filtered = filtered.filter(item => item.type === typeFilter);
        }

        if (branchFilter) {
            filtered = filtered.filter(item => item.branch === branchFilter);
        }

        return filtered;
    }, [combinedData, startDate, endDate, typeFilter, branchFilter]);


    const expenseClassification = {
        "50% Meal": ["50% meal"],
        "100% Meal": ["100% meal"],
        "Accounting Fees": ["accounting fees"],
        "Advertisement & Promotion": ["advertisement"],
        "Computer-Hardware": ["computer - hardware"],
        "Computer-Hosting": ["computer - hosting"],
        "Computer-Internet": ["computer - internet"],
        "Computer-Software": ["computer - software"],
        "Consultancy Fee for Job Support": ["consultancy fee for job support"],
        "Consultant and Non 1099 Expense": ["consultant and non 1099 expense"],
        "Consultant and 1099 Expense": ["consultant and 1099 expense"],
        "Contractor Expense": ["contractor expense"],
        "Corporate Insurance": ["corporate insurance"],
        "Corporate Tax": ["corporate tax"],
        "Dues & Subscriptions": ["dues & subscriptions"],
        "Education": ["education"],
        "Education & Training": ["education & training"],
        "Equity - Contribution": ["equity - contribution"],
        "Estimated Tax": ["estimated tax"],
        "Gain on Sale of Asset": ["gain on sale of asset"],
        "Income Tax Liability": ["income tax liability"],
        "Income Tax": ["income tax"],
        "Insurance": ["insurance"],
        "Insurance - Disability": ["insurance - disability"],
        "Insurance - Unemployment": ["insurance - unemployment"],
        "Insurance - General Liability": ["insurance - general liability"],
        "Insurance - Vehicles": ["insurance - vehicles"],
        "Interest Expense": ["interest expense"],
        "License & Fees": ["license & fees"],
        "Meals": ["meals"],
        "Meals and Entertainment": ["meals and entertainment"],
        "Office Expense": ["office expense"],
        "Office Supplies": ["office supplies"],
        "Owner's Compensation": ["owner's compensation"],
        "Owner's contribution for Non 1099 Expense": ["owner's contribution"],
        "Owner's Distribution for Non 1099 Expenses - Rifat Halim": ["owner's distribution for non 1099 expenses - rifat halim"],
        "Owner's Profit Distribution - Mohammad Farid Uddin": ["owner's profit distribution - mohammad farid uddin"],
        "Owner's Profit Distribution - Rifat Halim": ["owner's profit distribution - rifat halim"],
        "Owner's Profit Distribution": ["owner's profit distribution"],
        "Owner's Salary (W2)": ["owner's salary", "w2"],
        "Payroll Expense": ["payroll expense"],
        "Postal Fee": ["postal fee"],
        "Payroll Tax": ["payroll tax"],
        "Professional fee for Tax services": ["professional fee for tax services"],
        "Professional Fees": ["professional fees"],
        "Rent Expense": ["rent expense"],
        "Repairs & Maintenance": ["repairs & maintenance"],
        "Retainer": ["retainer"],
        "Shareholder Loan": ["shareholder loan"],
        "Software and Subscriptions": ["software and subscriptions"],
        "Taxes - Corporate Tax": ["taxes - corporate tax"],
        "Travel Expense": ["travel expense"],
        "Telephone - Wireless": ["telephone - wireless"],
        "Utilities": ["utilities"],
        "Wells Fargo Cash Back": ["wells fargo cash back"]
    };


    const getCategory = (description, type, classification) => {
        // Normalize classification and description to lowercase for case-insensitive comparison
        const normalizedDescription = description.toLowerCase();
        console.log(normalizedDescription);
        
        const normalizedClassification = classification ? classification.toLowerCase() : "";

        // For expenses (Withdrawal), use the classification field
        if (type === "Withdrawal") {
            // Check if classification contains "Equity"
            if (normalizedClassification.includes("equity")) {
                return "Equity";
            }
            if (normalizedClassification.includes("refund - income")) {
                return "Refund";
            }
            if (normalizedClassification === "1099 expense") {
                return "1099 Expense";
            }

            // Otherwise, check the classification against predefined categories
            for (const [category, keywords] of Object.entries(expenseClassification)) {
                if (keywords.some((keyword) => normalizedClassification.includes(keyword))) {
                    return category;
                }
            }
            return "Other Expense"; // Default for unclassified expenses
        }

        // For income (Deposit), retain description-based categorization
        if (type === "Deposit") {
            if (normalizedDescription.includes("job support")) return "Job Support";
            if (normalizedDescription.includes("accessibility testing")) return "Accessibility Testing";
            if (normalizedDescription.includes("software testing with selenium")) return "Software Testing with Selenium";
            if (normalizedDescription.includes("cyber security for professional")) return "Cyber Security for Professional";
            if (normalizedDescription.includes("data analysis with python")) return "Data Analysis with Python";
            if (normalizedDescription.includes("cost of goods sold")) return "Cost of Goods Sold";
            if (normalizedDescription.includes("basic computing for it help desk support")) return "Basic Computing for IT Help Desk Support";
            if (normalizedDescription.includes("bi developer with power bi & sql server")) return "BI Developer with Power BI & SQL Server";
            if (normalizedDescription.includes("net training")) return ".NET Training";
            if (normalizedDescription.includes("full stack software tester")) return "Full Stack Software Tester";

            return "Other Income"; // Default for unclassified income
        }

        return "Uncategorized"; // Default for uncategorized items
    };


    const { totalIncome, totalExpense, totalCOGS, groupedIncome, groupedExpense, otherIncomeDetails, otherExpenseDetails, equityAndRefundDetails, totalEquity,
        totalRefund } = useMemo(() => {
            let totalIncome = 0;
            let totalExpense = 0;
            let totalCOGS = 0;
            let totalEquity = 0;
            let totalRefund = 0;
            const groupedIncome = {};
            const groupedExpense = {};
            const otherIncomeDetails = [];
            const otherExpenseDetails = [];
            const equityAndRefundDetails = [];

            filteredData.forEach((item) => {
                const amount = parseFloat(item.amount);
                if (isNaN(amount)) return;

                const category = getCategory(item.description, item.type, item.classification);

                if (category === "Equity" || category === "Refund") {
                    equityAndRefundDetails.push({ ...item, category });

                    if (category === "Equity") {
                        totalEquity += amount;
                    } else if (category === "Refund") {
                        totalRefund += amount;
                    }

                    return;
                }

                if (item.type === "Deposit") {
                    totalIncome += amount;

                    if (category === "Other Income") {
                        otherIncomeDetails.push(item);
                    }

                    groupedIncome[category] = (groupedIncome[category] || 0) + amount;
                } else if (item.type === "Withdrawal") {
                    totalExpense += amount;

                    if (category === "Cost of Goods Sold") {
                        totalCOGS += amount; // Add to COGS if it's a withdrawal for COGS
                    }

                    if (category === "Other Expense") {
                        otherExpenseDetails.push(item);
                    }

                    groupedExpense[category] = (groupedExpense[category] || 0) + amount;
                }
            });

            return {
                totalIncome,
                totalExpense,
                totalCOGS,
                groupedIncome,
                groupedExpense,
                otherIncomeDetails,
                otherExpenseDetails,
                equityAndRefundDetails,
                totalEquity,
                totalRefund,
            };
        }, [filteredData]);


    // Calculate Gross Profit and Profit/Loss
    const grossProfit = totalIncome - totalCOGS;
    const profitLoss = grossProfit - totalExpense;

    let result = '';
    if (totalIncome > totalExpense) {
        result = `Profit: $${profitLoss.toFixed(2)}`;
    } else if (totalExpense > totalIncome) {
        result = `Loss: $${Math.abs(profitLoss).toFixed(2)}`;
    } else {
        result = 'No Profit/Loss (Income equals Expense)';
    }


    // Pagination
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };


    // Function to handle CSV data
    const handleCSVData = () => {
        return filteredData.map(item => ({
            Date: item.date || 'Not Given',
            Description: item.description,
            Type: item.type,
            Amount: item.amount,
            Branch: item.branch
        }));
    };

    // Function to generate PDF report
    const generatePDF = () => {
        const doc = new jsPDF();

        // Add company logo and title
        const companyName = 'QA Tek Solutions Inc.';
        const companyAddress = '118-35 Queens Blvd., Suite 400';
        const companyAddressLine2 = 'Forest Hills, New York 11375';
        const companyPhone = '(347) 259-1930, (347) 658-9284';
        const companyEmail = 'admin@qateksolutions.com';
        const companyWebsite = 'www.qateksolutions.com';
        const reportTitle = 'Profit and Loss';
        const dateRange = startDate && endDate
            ? `For the period from ${new Date(startDate).toLocaleDateString()} to ${new Date(endDate).toLocaleDateString()}`
            : `For the year ${new Date().getFullYear()}`;

        // Add QA Tek logo
        doc.addImage(qatekLogo, 'PNG', 160, 10, 30, 30);

        // Document title and header
        doc.setFontSize(18);
        doc.setTextColor(40, 40, 40);
        doc.text(companyName, 14, 20);

        // Add company contact information
        doc.setFontSize(10);
        doc.setTextColor(80, 80, 80);
        doc.text(companyAddress, 14, 30);
        doc.text(companyAddressLine2, 14, 35);
        doc.text(`Phone: ${companyPhone}`, 14, 40);
        doc.text(`Email: ${companyEmail}`, 14, 45);
        doc.text(`Website: ${companyWebsite}`, 14, 50);

        // Report title
        doc.setFontSize(16);
        doc.setTextColor(40, 40, 40);
        doc.text(reportTitle, 14, 60);

        // Date range
        doc.setFontSize(10);
        doc.text(dateRange, 14, 70);

        // Income section
        doc.setFontSize(14);
        doc.setTextColor(70, 70, 70);
        doc.text('Income', 14, 80);

        // Income details table
        const incomeRows = [];

        Object.entries(groupedIncome).forEach(([category, amount]) => {
            incomeRows.push([category, `$${amount.toFixed(2)}`]);
        });

        if (incomeRows.length > 0) {
            doc.autoTable({
                startY: 85,
                head: [['Income Category', 'Amount']],
                body: incomeRows,
                theme: 'grid',
                headStyles: { fillColor: [220, 220, 220], textColor: [40, 40, 40] },
                styles: { fontSize: 10 },
                columnStyles: {
                    0: { cellWidth: 130 },
                    1: { cellWidth: 50, halign: 'right' }
                }
            });
        }

        // Total Income
        const incomeEndY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 5 : 85;
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text('Total Income', 14, incomeEndY);
        doc.text(`$${totalIncome.toFixed(2)}`, 190, incomeEndY, { align: 'right' });

        // Expense section
        doc.setFontSize(14);
        doc.setFont(undefined, 'normal');
        doc.text('Expense', 14, incomeEndY + 10);

        // Expense details table
        const expenseRows = [];

        Object.entries(groupedExpense).forEach(([category, amount]) => {
            expenseRows.push([category, `$${amount.toFixed(2)}`]);
        });

        if (expenseRows.length > 0) {
            doc.autoTable({
                startY: incomeEndY + 15,
                head: [['Expense Category', 'Amount']],
                body: expenseRows,
                theme: 'grid',
                headStyles: { fillColor: [220, 220, 220], textColor: [40, 40, 40] },
                styles: { fontSize: 10 },
                columnStyles: {
                    0: { cellWidth: 130 },
                    1: { cellWidth: 50, halign: 'right' }
                }
            });
        }

        // Total Expense
        const expenseEndY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 5 : incomeEndY + 15;
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text('Total Expense', 14, expenseEndY);
        doc.text(`$${totalExpense.toFixed(2)}`, 190, expenseEndY, { align: 'right' });

        // COGS
        doc.setFontSize(12);
        doc.setFont(undefined, 'normal');
        doc.text('Total Cost of Goods Sold (COGS)', 14, expenseEndY + 10);
        doc.text(`$${totalCOGS.toFixed(2)}`, 190, expenseEndY + 10, { align: 'right' });

        // Gross Profit
        doc.setFontSize(12);
        doc.text('Gross Profit', 14, expenseEndY + 20);
        doc.text(`$${grossProfit.toFixed(2)}`, 190, expenseEndY + 20, { align: 'right' });

        // Profit/Loss
        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        const profitLossText = profitLoss >= 0 ? 'Net Profit' : 'Net Loss';
        doc.text(profitLossText, 14, expenseEndY + 30);
        doc.text(`$${Math.abs(profitLoss).toFixed(2)}`, 190, expenseEndY + 30, { align: 'right' });

        // Footer with date
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setFont(undefined, 'normal');
            doc.text(
                `Printed on: ${new Date().toLocaleDateString()} - Page ${i} of ${pageCount}`,
                190,
                285,
                { align: 'right' }
            );
        }

        // Get current date for the filename
        const date = new Date();
        const dateStr = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        doc.save(`income_statement_${dateStr}.pdf`);
    };

    // Function to get formatted date for filenames
    const getFormattedDate = () => {
        const date = new Date();
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    };

    const selectStyle = {
        backgroundColor: '#EAEFF4',
        boxSizing: 'border-box',
        border: '2px solid #CDCDCD',
        borderRadius: '5px',
        padding: '0.5rem',
        margin: '0.5rem',
        fontSize: '1rem',
        width: '20rem'
    };

    return (
        <div>

            <div className="layout-title">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p style={{ marginRight: '15px', marginBottom: '0' }}>Transaction Summary</p>
                    <h3 style={{
                        margin: '0',
                        color: '#666',
                        fontWeight: 'normal',
                        fontSize: '1.1rem'
                    }}>
                        {new Date(startDate).getFullYear()}
                    </h3>
                </div>
                <div className="align-right">
                    <FilledRoundedButton
                        name="Export PDF"
                        size="medium"
                        onClickHandler={generatePDF}
                        color="primary"
                        style={{ marginRight: '10px' }}
                    />
                    <CSVLink
                        data={handleCSVData()}
                        filename={`income_statement_${getFormattedDate()}.csv`}
                        style={{
                            border: '1px solid #1976d2',
                            color: '#1976d2',
                            padding: '8px 15px',
                            textAlign: 'center',
                            textDecoration: 'none',
                            display: 'inline-block',
                            fontSize: '14px',
                            cursor: 'pointer',
                            borderRadius: '5px',
                            backgroundColor: 'white'
                        }}
                    >
                        Export CSV
                    </CSVLink>
                </div>
            </div>

            <div>
                <div className="align-left border border-radius">
                    <FilledRoundedButton name="Filters" size="medium" onClickHandler={toggleFilter} color="secondary" />
                </div>
                {filterOpen && (
                    <div>
                        <div className="filter-body-left">
                            <TextInput id="from" name="from" placeholder="From" type="date" size="small" onChangeHandler={(e) => setStartDate(e.target.value)} value={startDate} />
                            <TextInput id="to" name="to" placeholder="To" type="date" size="small" onChangeHandler={(e) => setEndDate(e.target.value)} value={endDate} />

                            <div>
                                <label htmlFor="typeFilter">Type:</label>
                                <select
                                    id="typeFilter"
                                    value={typeFilter}
                                    onChange={(e) => setTypeFilter(e.target.value)}
                                    style={selectStyle}
                                >
                                    <option value="">All</option>
                                    <option value="Deposit">Deposit</option>
                                    <option value="Withdrawal">Withdrawal</option>
                                </select>
                            </div>

                            <div>
                                <label htmlFor="branchFilter">Branch:</label>
                                <select
                                    id="branchFilter"
                                    value={branchFilter}
                                    onChange={(e) => setBranchFilter(e.target.value)}
                                    style={selectStyle}
                                >
                                    <option value="">All</option>
                                    {branches.map((branch, index) => (
                                        <option key={index} value={branch}>{branch}</option>
                                    ))}
                                    <option value="Online">Online</option>
                                </select>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {loading ? (
                <Loading />
            ) : (
                <div>
                    {/* <div className="table-body">
                        <table style={{ width: '100%' }}>
                            <thead className="thead">
                                <tr>
                                    {tableHeader.map((th, i) => (
                                        <th className={`${th.size}-header`} key={i}>{th.name}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedData.map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.date || 'Not Given'}</td>
                                        <td>{item.description}</td>
                                        <td>{item.type}</td>
                                        <td>${item.amount}</td>
                                        <td>{item.branch}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <Pagination
                        style={{ marginRight: '1rem', display: 'flex', justifyContent: 'right' }}
                        color="primary"
                        count={totalPages}
                        variant="outlined"
                        shape="rounded"
                        page={currentPage}
                        onChange={handlePageChange}
                    /> */}


                    <div className="summary-section" style={{ padding: '1rem', borderTop: '1px solid #ddd' }}>
                        {/* Total Income and Total Expense */}
                        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '2rem', marginBottom: '1rem' }}>
                            <div>
                                <h4>Total Income:</h4>
                                <p style={{ color: 'green', fontWeight: 'bold' }}>${totalIncome.toFixed(2)}</p>
                            </div>
                            <div>
                                <h4>Total Expense:</h4>
                                <p style={{ color: 'red', fontWeight: 'bold' }}>${totalExpense.toFixed(2)}</p>
                            </div>
                        </div>
                        <hr />
                        {/* Gross Profit and Profit/Loss Calculation */}
                        <div style={{ marginBottom: '1rem' }}>
                            <h4>Gross Profit: <span style={{ fontWeight: 'bold' }}>${(totalIncome - totalCOGS).toFixed(2)}</span></h4>

                            <h4>Profit/Loss: <span style={{ fontWeight: 'bold', color: profitLoss >= 0 ? 'green' : 'red' }}>{profitLoss >= 0 ? 'Profit' : 'Loss'}: ${Math.abs(profitLoss).toFixed(2)}</span></h4>
                        </div>
                        <hr />
                        {/* Total Cost of Goods Sold */}
                        <div style={{ marginBottom: '1rem' }}>
                            <h4>Total Cost of Goods Sold (COGS): <span style={{ fontWeight: 'bold' }}>${totalCOGS.toFixed(2)}</span></h4>
                        </div>
                        <hr />
                        {/* Income Details Grouped by Category */}
                        <div>
                            <h4>Income Details (Grouped by Category):</h4>
                            <ul>
                                {Object.entries(groupedIncome).map(([category, amount], index) => (
                                    <li key={index} style={{ marginBottom: '0.5rem' }}>
                                        <strong>{category}</strong>: ${amount.toFixed(2)}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Other Income Details */}
                        {otherIncomeDetails.length > 0 && (
                            <div style={{ marginTop: '1rem' }}>
                                <h4>Other Income Details:</h4>
                                <ul>
                                    {otherIncomeDetails.map((item, index) => {
                                        const amount = parseFloat(item.amount);
                                        return (
                                            <li key={index}>
                                                {item.description} - ${isNaN(amount) ? 'Invalid amount' : amount.toFixed(2)}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                        <hr />
                        {/* Expense Details */}
                        <section style={{ marginBottom: '1.5rem' }}>
                            <h4>Expense Details (Grouped by Category)</h4>
                            <ul>
                                {Object.entries(groupedExpense).map(([category, amount], index) => (
                                    <li key={index} style={{ marginBottom: '0.5rem' }}>
                                        <strong>{category}</strong>: ${amount.toFixed(2)}
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section style={{ marginBottom: '1.5rem' }}>
                            <h4>Equity and Refund Transactions</h4>
                            <ul>
                                {equityAndRefundDetails.map((item, index) => (
                                    <li key={index} style={{ marginBottom: '0.5rem' }}>
                                        <strong>{item.category} : </strong>  -
                                        {item.description} -
                                        <strong> Amount:</strong> ${parseFloat(item.amount).toFixed(2)}
                                    </li>
                                ))}
                            </ul>
                            <ul>
                                <li style={{ marginBottom: '0.5rem' }}><strong>Total Equity:</strong> ${totalEquity.toFixed(2)}</li>
                                <li> <strong>Total Refund:</strong> ${totalRefund.toFixed(2)}</li>
                            </ul>
                        </section>


                        {otherExpenseDetails.length > 0 && (
                            <div style={{ marginTop: '1rem' }}>
                                <h4>Other Expense Details:</h4>
                                <ul>
                                    {otherExpenseDetails.map((item, index) => {
                                        const amount = parseFloat(item.amount);
                                        return (
                                            <li key={index}>
                                                {item.classification} - ${isNaN(amount) ? 'Invalid amount' : amount.toFixed(2)}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>


                </div>
            )}
        </div>
    );
}

export default IncomeStatement;



